module.exports = __webpack_public_path__ + "img/use_selected.9646d993.svg";